<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      row-id="fabricCode"
      :radio-config="{ highlight: true, trigger: 'row' }"
      :checkbox-config="{
        highlight: true,
        reserve: true
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.fabricStatus === 'Y' ? 'success' : 'danger'"
        >
          {{ row.fabricStatusName }}
        </el-tag>
      </template>
      <template v-slot:widAndWeight="{ row }">
        <span>{{ row.wid }} {{ row.widUnit }}</span>
        <br />
        <span>{{ row.fabricWeight }} {{ row.fabricWeightUnit }}</span>
      </template>
      <template v-slot:priceInfo="{ row }">
        <span>{{ row.unitPrice }} 元/ {{ row.fabricUnit }}</span>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    tablePage: { type: Object, default: null },
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    type: String
  },
  data() {
    return {
      tableHeight: 600,
      turnoverVisible: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        }
      },
      tableColumn: [
        {
          field: 'seq',
          width: 60,
          fixed: 'left',
          align: 'center',
          type: 'seq'
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
          visible: this.type === 'checkbox'
        },
        {
          field: 'radio',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'radio',
          visible: this.type === 'radio'
        },
        {
          field: 'defaultImageUrl',
          width: 120,
          title: this.$l('INDEX.table_label_image') || '图片',
          align: 'center',
          slots: { default: 'defaultImageUrl' }
        },
        {
          field: 'fabricNo',
          minWidth: 180,
          title: this.$l('INDEX.choose_fabric_fabricNo') || '面料编号'
        },
        {
          field: 'fabricName',
          minWidth: 250,
          title: this.$l('INDEX.choose_fabric_fabricName') || '面料名称'
        },
        {
          field: 'fabricContent',
          minWidth: 200,
          title: this.$l('INDEX.choose_fabric_fabricComposition') || '面料成分'
        },
        {
          field: 'widAndWeight',
          minWidth: 150,
          title: this.$l('INDEX.choose_fabric_wid_and_weight') || '门幅克重',
          slots: { default: 'widAndWeight' }
        },  
        {
          field: 'priceInfo',
          minWidth: 150,
          title: this.$l('INDEX.choose_fabric_unitPrice') || '单价',
          slots: { default: 'priceInfo' }
        },
        {
          field: 'fabricAgentName',
          width: 150,
          title: this.$l('INDEX.choose_fabric_agent') || '业务员'
        },
        {
          field: 'supName',
          minWidth: 250,
          title: this.$l('INDEX.choose_fabric_supName') || '供应商'
        },
        {
          field: 'factoryNumber',
          minWidth: 180,
          title:
            this.$l('INDEX.choose_fabric_factoryFabricNumber') || '工厂面料编号'
        },
        {
          field: 'fabricStatus',
          width: 100,
          title: this.$l('INDEX.form_label_status') || '状态',
          align: 'center',
          slots: { default: 'status' }
        },
        {
          field: 'createInfo',
          width: 170,
          title: this.$l('INDEX.creator') || '上传信息',
          slots: { default: 'createInfo' }
        },
        {
          field: 'modifyInfo',
          width: 170,
          title: this.$l('INDEX.table_label_modified_by') || '修改信息',

          slots: { default: 'modifyInfo' }
        }
      ]
    }
  },
  methods: {
    choiceData() {
      if (this.type === 'checkbox') {
        return this.getCheckboxRecords()
      }
      if (this.type === 'radio') {
        return this.getRadioRecord()
      }
    },
    getRadioRecord() {
      const data = this.$refs.table.getRadioRecord()
      if (!data) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning'
        })
        return
      }
      return data
    },
    getCheckboxRecords() {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())

      if (!data.length) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_data') || '请选择数据!!',
          type: 'warning'
        })
        return
      }
      return data
    }
  }
}
</script>
<style lang="scss" scoped>
// .fabric-tree {
//   height: 550px;
//   overflow-y: auto;
//   &::-webkit-scrollbar {
//     width: 10px; /*滚动条宽度*/
//   }
// }
</style>
